var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrescriptionBottleMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 448C32 483.199 60.801 512 96 512H288C323.199 512 352 483.199 352 448V128H32V448ZM96 304C96 295.199 103.199 288 112 288H160V240C160 231.199 167.199 224 176 224H208C216.801 224 224 231.199 224 240V288H272C280.801 288 288 295.199 288 304V336C288 344.799 280.801 352 272 352H224V400C224 408.799 216.801 416 208 416H176C167.199 416 160 408.799 160 400V352H112C103.199 352 96 344.799 96 336V304ZM360 0H24C10.75 0 0 10.75 0 24V72C0 85.25 10.75 96 24 96H360C373.25 96 384 85.25 384 72V24C384 10.75 373.25 0 360 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionBottleMedical);
export default __webpack_public_path__ + "static/media/prescription-bottle-medical.72cdf4b755c7485418eb7b0753fa61bf.svg";
export { ForwardRef as ReactComponent };